import React, { useEffect, useRef } from "react";

import Typography from "../Typography";

import "./audio-visualizer.css";

import { ReactComponent as CallIcon } from "../../build/images/viewactioncall.svg";

const AudioWaveform = ({ audioElement }) => {
  const canvasRef = useRef(null);

  const renderCallAnimation = () => {
    return (
      <div className="audio-wave">
        <div class="icon-container">
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="icon">
            <CallIcon />
          </div>
        </div>
        <Typography.H2 color={"blue-selected-4"}>Em chamada...</Typography.H2>
      </div>
    );
  };

  return renderCallAnimation();
};

export default AudioWaveform;
